import React, { useEffect, useState } from 'react';
import { useApi } from '../hooks/useApi';
import { useAuth } from '../context/AuthContext';
import Modal from '../components/ui/Modal';
import toast from 'react-hot-toast';
import { Plus, Pencil, Trash2, Search, MapPin } from 'lucide-react';

export default function Cities() {
  const api = useApi();
  const { can } = useAuth();
  const [cities, setCities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ code: '', name: '', link: '' });
  const [saving, setSaving] = useState(false);

  useEffect(() => { load(); }, []);
  async function load() {
    setLoading(true);
    const d = await api.get('/cities');
    if (d) setCities(d.cities || []);
    setLoading(false);
  }

  function openAdd() { setForm({ code: '', name: '', link: '' }); setModal('add'); }
  function openEdit(c) { setForm({ code: c.code, name: c.name, link: c.link || '' }); setModal(c); }

  async function save() {
    if (!form.code.trim() || !form.name.trim()) return toast.error('Code aur naam zaroori hain');
    setSaving(true);
    try {
      if (modal === 'add') {
        const d = await api.post('/cities', form);
        if (d?.city) { toast.success('City add ho gayi!'); load(); setModal(null); }
        else toast.error(d?.error || 'Error');
      } else {
        const d = await api.put('/cities/' + modal.id, form);
        if (d?.success) { toast.success('Update ho gaya!'); load(); setModal(null); }
        else toast.error(d?.error || 'Error');
      }
    } finally { setSaving(false); }
  }

  async function toggle(c) {
    await api.put('/cities/' + c.id, { name: c.name, link: c.link, is_active: !c.is_active });
    load();
  }

  async function del(c) {
    if (!window.confirm(`"${c.name}" delete karein?`)) return;
    const d = await api.del('/cities/' + c.id);
    if (d?.success) { toast.success('Delete ho gaya'); load(); }
  }

  const filtered = cities.filter(c =>
    c.name?.toLowerCase().includes(search.toLowerCase()) ||
    c.code?.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="page">
      <div className="page-header">
        <div className="section-title">🕌 Cities / Groups</div>
        <div className="section-sub">WhatsApp group cities manage karein</div>
      </div>

      <div className="page-actions">
        <div className="search-wrap" style={{ flex: 1, maxWidth: 300 }}>
          <Search size={13} className="search-icon" />
          <input className="input" placeholder="Search karein..." value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        {can('cities') && (
          <button className="btn btn-primary" onClick={openAdd}><Plus size={14} /> Nai City</button>
        )}
      </div>

      <div className="card">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 40 }}><span className="spinner" /></div>
        ) : filtered.length === 0 ? (
          <div className="empty"><div className="empty-icon"><MapPin size={36} /></div>Koi city nahi mili</div>
        ) : (
          <div className="table-wrap">
            <table>
              <thead><tr><th>Code</th><th>City Name</th><th>Group Link</th><th>Status</th><th>Actions</th></tr></thead>
              <tbody>
                {filtered.map(c => (
                  <tr key={c.id}>
                    <td><span className="badge badge-gold">{c.code}</span></td>
                    <td style={{ fontWeight: 500, color: 'var(--text-primary)' }}>{c.name}</td>
                    <td>{c.link ? <a href={c.link} target="_blank" rel="noreferrer" style={{ fontSize: 12 }}>🔗 Group</a> : <span style={{ color: 'var(--text-muted)' }}>—</span>}</td>
                    <td>
                      {can('cities') ? (
                        <label className="toggle">
                          <input type="checkbox" checked={!!c.is_active} onChange={() => toggle(c)} />
                          <span className="toggle-slider" />
                        </label>
                      ) : (
                        <span className={`badge ${c.is_active ? 'badge-green' : 'badge-grey'}`}>{c.is_active ? 'Active' : 'Off'}</span>
                      )}
                    </td>
                    <td>
                      <div style={{ display: 'flex', gap: 6 }}>
                        {can('cities') && <>
                          <button className="btn btn-icon btn-ghost btn-sm" onClick={() => openEdit(c)}><Pencil size={13} /></button>
                          <button className="btn btn-icon btn-danger btn-sm" onClick={() => del(c)}><Trash2 size={13} /></button>
                        </>}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {modal && (
        <Modal
          title={modal === 'add' ? '🕌 Nai City Add Karein' : '✏️ City Edit Karein'}
          onClose={() => setModal(null)}
          footer={<>
            <button className="btn btn-ghost" onClick={() => setModal(null)}>Cancel</button>
            <button className="btn btn-primary" onClick={save} disabled={saving}>
              {saving ? <span className="spinner" style={{ width: 14, height: 14 }} /> : null}
              {modal === 'add' ? ' Add Karein' : ' Save Karein'}
            </button>
          </>}
        >
          <div className="field">
            <label className="label">City Code * (e.g. LHR, KHI)</label>
            <input className="input" placeholder="LHR" value={form.code} onChange={e => setForm(p => ({ ...p, code: e.target.value.toUpperCase() }))} autoFocus />
          </div>
          <div className="field">
            <label className="label">City Name *</label>
            <input className="input" placeholder="Lahore" value={form.name} onChange={e => setForm(p => ({ ...p, name: e.target.value }))} />
          </div>
          <div className="field">
            <label className="label">WhatsApp Group Link</label>
            <input className="input" placeholder="https://chat.whatsapp.com/..." value={form.link} onChange={e => setForm(p => ({ ...p, link: e.target.value }))} />
          </div>
        </Modal>
      )}
    </div>
  );
}